import Api from '../api/api.js';

import Modal from '../alerts/modal.js';


export default class AddressFinder {


  constructor(params = {})
  {
    this.setParams(params);
  }


  setParams(params = {})
  {
    const defaults = {
      myLatLng:{
        lat:54.9783, 
        lng:-1.6178  
      },
      markerTitle:'NO ADDRESS SPECIFIED',
      callback:'INVALID'
    }
    this.params = $.extend({}, defaults, params);
    return this;
  }


  getAddressComponent(place, type)
  { 
    var components = place['address_components'];
    var segment = components.filter(function(comp) {  
      return comp['types'].indexOf(type) > -1;
    });
    if (segment.length > 0) {
      return segment[0];
    }
    return false;
  }


  updateAddress(address)
  {
    const url = this.params['updateUrl'];

    return new Promise((resolve, reject) => {

      (new Api).putRequest(url, address).then((response) => {
        
        resolve(response);
      
      });

    })
  }


  updateSuccessful() 
  {
    (new Modal).success('Success', 'Address updated', 'Ok').then(function() {

      window.location.reload();

    })

    return this;
  }


  initMap()
  {
    const _this = this;

    var map = new google.maps.Map(document.getElementById('map'), {
      center: this.params.myLatLng,
      zoom: 13
    });

    var input = document.getElementById('pac-input');

    var autocomplete = new google.maps.places.Autocomplete(input);
    
    autocomplete.bindTo('bounds', map);

    map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

    var infowindow = new google.maps.InfoWindow();

    var marker = new google.maps.Marker({
      position:this.params.myLatLng,
      map:map,
      title:this.params.markerTitle
    });

    marker.addListener('click', function() {
      infowindow.open(map, marker);
    });

    autocomplete.addListener('place_changed', function() {
      infowindow.close();
      var place = autocomplete.getPlace();

      if (!place.geometry) {
        return;
      }

      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);
      }

      const country = _this.getAddressComponent(place, 'country');

      const updatedAddress = {
        latitude:  parseFloat(place.geometry.location.lat().toFixed(8)),
        longitude: parseFloat(place.geometry.location.lng().toFixed(8)),
        address:   place.formatted_address,
        country:   country['short_name']
      }

      _this.updateAddress.call(_this, updatedAddress).then(() => {
        _this.updateSuccessful();
      });

      // Set the position of the marker using the place ID and location.
      marker.setPlace({
        placeId:  place.place_id,
        location: place.geometry.location
      });
      marker.setVisible(true);

      infowindow.open(map, marker);
    });

  }

}